<div class="container" *ngIf="!valueOnly; else showReadOnly">
  <ds-icon-badge *ngIf="internal" [iconClass]="iconClass" [tooltip]="tooltip"></ds-icon-badge>
  <label [class]="typography" [for]="for">{{ text }}{{ isFieldRequired ? '*' : '' }}</label>
</div>
<ng-template #showReadOnly >
  <label [class]="typography" [for]="for">{{ text }}</label>
</ng-template>
